import { T } from "@/locales";

export const columns = [
  {
    title: T("序号"),
    dataIndex: "index",
    fixed: "left",
    width: 60,
    customRender: (value, item, index) => index + 1,
  },
  {
    title: T("上架单号"),
    dataIndex: "shelve_order_number",
    fixed: "left",
    width: 180,
    ellipsis: true,
    scopedSlots: { customRender: "shelve_order_number" },
  },
  {
    title: T("入库通知单号"),
    dataIndex: "receipt_order_number",
    width: 180,
    ellipsis: true,
    scopedSlots: { customRender: "receipt_order_number" },
  },
  {
    title: T("仓库"),
    dataIndex: "warehouse_name",
    width: 120,
    ellipsis: true,
    customRender: (value, item) => item.warehouse_item.name,
  },
  {
    title: T("货主"),
    dataIndex: "client_name",
    width: 120,
    ellipsis: true,
    customRender: (value, item) => item.client_item.name,
  },
  {
    title: T("状态"),
    dataIndex: "is_void",
    width: 120,
    ellipsis: true,
    customRender: (value, item) => (item.is_void ? T("已作废") : T("已上架")),
  },
  {
    title: T("操作人"),
    dataIndex: "creator_name",
    width: 120,
    ellipsis: true,
    customRender: (value, item) => item.creator_item.name,
  },
  {
    title: T("创建时间"),
    dataIndex: "create_time",
    sorter: true,
    width: 180,
    ellipsis: true,
  },
  {
    title: T("操作"),
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    fixed: "right",
    width: 120,
    ellipsis: true,
  },
];
